import { defineNuxtPlugin } from 'nuxt/app';
import { handleImageError } from '~/utils/imageFallback';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      vueErrorImage: handleImageError
    }
  };
});
